/* ナマエノアトリエ: 分割払い表示用フォームの誤送信防止 */
(function () {
  function guard(form) {
    if (!form || form.__nmaGuarded) return;
    form.__nmaGuarded = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }, true);
  }
  function scan() {
    var forms = document.querySelectorAll('form.installment[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) guard(forms[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  try {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  } catch (err) {}
})();
